// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'diamond-solid';

export const Component = () => (
  <path d='M23.702 11.822a1 1 0 0 1 0 1.415L13.237 23.702a1 1 0 0 1-1.415 0L1.357 13.237a1 1 0 0 1 0-1.415L11.822 1.357a1 1 0 0 1 1.415 0l10.465 10.465Z' />
);

export const viewBox = '0 0 25 25';
